<template>
  <draggable class="menu-config-list ui-sortable" tag="ul" :list="tasks" :group="{ name: 'g1' }" @change="onChange">
    <template v-for="el in tasks">
      <li>
        <nav-menu :el="el" :bus="bus" :key="el.id"></nav-menu>
        <nested-draggable :tasks="el.children" :bus="bus" :parent="el.id"/>
      </li>
    </template>
  </draggable>
</template>
<script>
  import NavMenu from '@/components/NavMenu'
  import draggable from 'vuedraggable'
  export default {
    props: {
      tasks: {
        required: true,
        type: Array
      },
      bus: Object,
      parent: Number
    },
    components: {
      draggable,
      NavMenu
    },
    data () {
      return {
        selectedId: ''
      }
    },
    created () {
    },
    methods: {
      select (el) {
        this.bus.$emit('select', el)
      },
      onChange (val) {
        let update = {}
        let newVal
        if (val.moved || val.added) {

          newVal = val.moved || val.added
          update = newVal.element
          update.parent_id = this.parent || 1
          update.sequence = newVal.newIndex + 1
          this.bus.$emit('updateTree', update)
        }
      }
    },
    name: "nested-draggable"
  };
</script>
<style scoped>
  .dragArea {
    min-height: 50px;
    outline: 1px dashed;
  }
</style>
